export default __webpack_public_path__ + "static/media/042-forbidden.6d5dd81b.png";